import { render, staticRenderFns } from "./selfCourse.vue?vue&type=template&id=399afa5a&scoped=true"
import script from "./selfCourse.vue?vue&type=script&lang=ts"
export * from "./selfCourse.vue?vue&type=script&lang=ts"
import style0 from "./selfCourse.vue?vue&type=style&index=0&id=399afa5a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "399afa5a",
  null
  
)

export default component.exports